import { renderTimeZoneMap, currentTimeZoneMap, orgPrimaryEmail } from "@state/local-storage";
import { getTimeZoneGuess, ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";
import { getTimeZones } from "@clockwise/web-commons/src/util/time-zone.util";

//////////////////////////
// TIME ZONES CONST
//////////////////////////

export const TimeZones: { [s: string]: string } = getTimeZones();

//////////////////////////
// SMALL UTILs
//////////////////////////

export function getRenderTimeZone(): string {
  const email = orgPrimaryEmail.get();
  return (email && renderTimeZoneMap.get(email)) || getTimeZoneGuess();
}

export function setRenderTimeZone(tz: string): void {
  const email = orgPrimaryEmail.get();
  if (email) {
    return renderTimeZoneMap.set(email, tz);
  }
}

export function getCurrentTimeZone(): string {
  const email = orgPrimaryEmail.get();
  return (email && currentTimeZoneMap.get(email)) || getTimeZoneGuess();
}

export function setCurrentTimeZone(tz: string): void {
  const email = orgPrimaryEmail.get();
  if (email) {
    return currentTimeZoneMap.set(email, tz);
  }
}

// here we override the default getRenderTimeZone defined by the common ZonedMoment
// this is to disassociate the ZonedMoment implementation from a localStorage dependency
ZonedMoment.getRenderTimeZone = () => {
  const email = orgPrimaryEmail.get();
  if (!email || !getRenderTimeZone()) {
    return getTimeZoneGuess();
  }
  return getRenderTimeZone();
};

export { getTimeZoneGuess, ZonedMoment };
